<template>
  <div class="bdgWrp">
    <ul class="clear">
      <li :class="{'active': cur === 'hours'}" @click="toggle('hours')">Hours</li>
      <li :class="{'active': cur === 'cost'}" @click="toggle('cost')">Cost</li>
    </ul>
    <div class="labour-wrp">
      <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="alignCenter">
        <el-table-column
          width="132"
          prop="week"
          label="WEEK ENDING">
        </el-table-column>
        <el-table-column
          label="MON">
          <template slot-scope="scope">
            <div v-if="scope.row.mon !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.mon}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="TUES">
          <template slot-scope="scope">
            <div v-if="scope.row.tues !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.tues}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="WED">
          <template slot-scope="scope">
            <div v-if="scope.row.wed !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.wed}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            
          </template>
        </el-table-column>
        <el-table-column
          label="THU">
          <template slot-scope="scope">
            <div v-if="scope.row.thu !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.thu}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="FRI">
          <template slot-scope="scope">
            <div v-if="scope.row.fri !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.fri}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="SAT">
          <template slot-scope="scope">
            <div v-if="scope.row.sat !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.sat}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="SUN">
          <template slot-scope="scope">
            <div v-if="scope.row.sun !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.sun}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="TOTAL">
          <template slot-scope="scope">
            <div v-if="scope.row.total !== null"><span v-if="scope.row.week === 'Average Cost' && cur === 'cost'">$</span>{{scope.row.total}}<span v-if="scope.row.week === 'Percentage'">%</span></div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <template slot="empty">
          <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
          <div v-else>-</div>
        </template>
      </el-table>
    </div>
    <div class="labour-wrp" style="padding-bottom:50px">
      <el-table
          :data="tableData2"
          border
          style="width: 100%"
          class="alignCenter">
        <el-table-column
          width="152"
          prop="weekEndingStr"
          label="WEEK ENDING">
        </el-table-column>
        <el-table-column
          prop="mon"
          label="MON">
          <template slot-scope="scope">
            <div v-if="scope.row.mon !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.mon}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="tue"
          label="TUES">
          <template slot-scope="scope">
            <div v-if="scope.row.tue !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.tue}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="wed"
          label="WED">
          <template slot-scope="scope">
            <div v-if="scope.row.wed !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.wed}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="thu"
          label="THU">
          <template slot-scope="scope">
            <div v-if="scope.row.thu !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.thu}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fri"
          label="FRI">
          <template slot-scope="scope">
            <div v-if="scope.row.fri !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.fri}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="sat"
          label="SAT">
          <template slot-scope="scope">
            <div v-if="scope.row.sat !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.sat}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="sun"
          label="SUN">
          <template slot-scope="scope">
            <div v-if="scope.row.sun !== null"><span v-if="cur === 'cost'">$</span>{{scope.row.sun}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="TOTAL">
          <template slot-scope="scope">
            <div v-if="scope.row.total !== null || scope.row.total !== NaN"><span v-if="cur === 'cost'">$</span>{{scope.row.total}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <template slot="empty">
          <i v-if="loading2" class="el-icon-loading" style="font-size:20px"></i>
          <div v-else>-</div>
        </template>
      </el-table>
      <pageination :total="totalRecord" :size="pagesize" @togglePage="pageChange"></pageination>
    </div>
  </div>
</template>

<script>
import api from '../../../api/account'
import pageination from '../../../components/common/pageination'
import axios from 'axios'
const CancelToken = axios.CancelToken;

export default {
  data () {
    return {
      source: CancelToken.source(),
      loading: false,
      loading2: false,
      tableData: [],
      tableData2: [],
      page: 1,
      pagesize: 10,
      totalRecord: 0,
      cur: 'hours'
    }
  },
  created() {
    api.weekEndingOfHours({
      params: {
        pageNum: this.page,
        pageSize: this.pagesize,
        venueId: parseInt(this.$route.params.id)
      },
      cancelToken: this.source.token,
      callback: this.whCallback
    })
    api.weekEndingOfHoursList({
      params: {
        pageNum: this.page,
        pageSize: this.pagesize,
        venueId: parseInt(this.$route.params.id)
      },
      cancelToken: this.source.token,
      callback: this.whlCallback
    })
  },
  methods: {
    pageChange (page) {
      this.page = page
      this.toggle(this.cur)
    },
    whCallback (res) {
      var that = this
      if(res.data.code == 0){
        that.tableData.push({})
        that.tableData.push({})
        that.tableData[0].week = 'Percentage'
        if (that.cur === 'hours')
          that.tableData[1].week = 'Average Hours'
        else if (that.cur === 'cost')
        that.tableData[1].week = 'Average Cost'

        that.tableData[0].mon = res.data.data.percentageMon
        if (that.cur === 'hours')
          that.tableData[1].mon = that.$box.formatDecimal2(res.data.data.avgMon, 2)
        else if (that.cur === 'cost')
          that.tableData[1].mon = that.$box.formatDecimal2(res.data.data.avgMon, 2)

        that.tableData[0].tues = res.data.data.percentageTue
        if (that.cur === 'hours')
          that.tableData[1].tues = that.$box.formatDecimal2(res.data.data.avgTue,2)
        else if (that.cur === 'cost')
          that.tableData[1].tues = that.$box.formatDecimal2(res.data.data.avgTue, 2)

        that.tableData[0].wed = res.data.data.percentageWed
        if (that.cur === 'hours')
          that.tableData[1].wed = that.$box.formatDecimal2(res.data.data.avgWed, 2)
        else if (that.cur === 'cost')
          that.tableData[1].wed = that.$box.formatDecimal2(res.data.data.avgWed, 2)

        that.tableData[0].thu = res.data.data.percentageThu
        if (that.cur === 'hours')
          that.tableData[1].thu = that.$box.formatDecimal2(res.data.data.avgThu, 2)
        else if (that.cur === 'cost')
          that.tableData[1].thu = that.$box.formatDecimal2(res.data.data.avgThu, 2)

        that.tableData[0].fri = res.data.data.percentageFri
        if (that.cur === 'hours')
          that.tableData[1].fri = that.$box.formatDecimal2(res.data.data.avgFri,2)
        else if (that.cur === 'cost')
          that.tableData[1].fri = that.$box.formatDecimal2(res.data.data.avgFri, 2)

        that.tableData[0].sat = res.data.data.percentageSat
        if (that.cur === 'hours')
          that.tableData[1].sat = that.$box.formatDecimal2(res.data.data.avgSat, 2)
        else if (that.cur === 'cost')
          that.tableData[1].sat = that.$box.formatDecimal2(res.data.data.avgSat, 2)

        that.tableData[0].sun = res.data.data.percentageSun
        if (that.cur === 'hours')
          that.tableData[1].sun = that.$box.formatDecimal2(res.data.data.avgSun, 2)
        else if (that.cur === 'cost')
          that.tableData[1].sun = that.$box.formatDecimal2(res.data.data.avgSun, 2)

        that.tableData[0].total = res.data.data.percentageTotal
        if (that.cur === 'hours')
          that.tableData[1].total = that.$box.formatDecimal2(res.data.data.avgTotal, 2)
        else if (that.cur === 'cost')
          that.tableData[1].total = that.$box.formatDecimal2(res.data.data.avgTotal, 2)
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    whlCallback (res) {
      var that = this
      that.loading2 = false
      if(res.data.code == 0){
        if (this.cur === 'hours') {
          res.data.data.list.forEach(item => {
            item.total = that.$box.formatDecimal2(item.fri + item.mon +
            item.sat + item.sun + item.thu + item.tue + item.wed, 2)
            item.fri = that.$box.formatDecimal2(item.fri, 2)
            item.mon = that.$box.formatDecimal2(item.mon, 2)
            item.sat = that.$box.formatDecimal2(item.sat, 2)
            item.sun = that.$box.formatDecimal2(item.sun, 2)
            item.thu = that.$box.formatDecimal2(item.thu, 2)
            item.tue = that.$box.formatDecimal2(item.tue, 2)
            item.wed = that.$box.formatDecimal2(item.wed, 2)
            item.weekEnding = that.$box.formatDateMonthyear(item.weekEnding, 2)
          })
        } else {
          res.data.data.list.forEach(item => {
            item.total = that.$box.formatDecimal2(item.fri + item.mon +
            item.sat + item.sun + item.thu + item.tue + item.wed, 2)
            item.fri = that.$box.formatDecimal2(item.fri, 2)
            item.mon = that.$box.formatDecimal2(item.mon, 2)
            item.sat = that.$box.formatDecimal2(item.sat, 2)
            item.sun = that.$box.formatDecimal2(item.sun, 2)
            item.thu = that.$box.formatDecimal2(item.thu, 2)
            item.tue = that.$box.formatDecimal2(item.tue, 2)
            item.wed = that.$box.formatDecimal2(item.wed, 2)
            item.weekEnding = that.$box.formatDateMonthyear(item.weekEnding, 2)
          })
        }
        that.tableData2 = res.data.data.list
        that.totalRecord = res.data.data.total
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    toggle (type) {
      this.loading = true
      this.tableData = []
      this.tableData2 = []
      if (this.loading) {
        this.source.cancel('Operationcanceled');
        this.source = null
        this.source = CancelToken.source();
      }
      if (type === 'hours') {
        this.cur = 'hours'
        api.weekEndingOfHours({
          params: {
            pageNum: this.page,
            pageSize: this.pagesize,
            venueId: parseInt(this.$route.params.id)
          },
          cancelToken: this.source.token,
          callback: this.whCallback
        })
        api.weekEndingOfHoursList({
          params: {
            pageNum: this.page,
            pageSize: this.pagesize,
            venueId: parseInt(this.$route.params.id)
          },
          cancelToken: this.source.token,
          callback: this.whlCallback
        })
      } else {
        this.cur = 'cost'
        api.weekEndingOfCost({
          params: {
            pageNum: this.page,
            pageSize: this.pagesize,
            venueId: parseInt(this.$route.params.id)
          },
          cancelToken: this.source.token,
          callback: this.whCallback
        })
        api.weekEndingOfCostList({
          params: {
            pageNum: this.page,
            pageSize: this.pagesize,
            venueId: parseInt(this.$route.params.id)
          },
          cancelToken: this.source.token,
          callback: this.whlCallback
        })
      }
    }
  },
  components: {
    pageination
  }
}
</script>

<style lang="scss" scoped>
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
  ul{
    width: 100%;
    margin-bottom: 22px;
    li{
      width:140px;
      height:40px;
      float: left;
      background-color: transparent;
      font-size:18px;
      font-family:'PingFangSC-Semibold';
      color: #fff;
      border:2px solid rgba(255,255,255,1);
      text-align:center;
      line-height: 40px;
      cursor: pointer;
    }
    .active{
      border:2px solid rgba(234,55,150,1);
      color: rgba(234,55,150,1);
    }
  }
  .labour-wrp{
    width: 100%;
    background: #151C27;
    margin-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/labour/index.vue